/**
 * This file contains all swedish translations (messages) used in the web app.
 * Must be a flat key-value object where keys are sorted in alphanumerical order.
 * We are using the ICU message syntax: https://formatjs.io/guides/message-syntax/
 * Format keys using upper snake case and name them by a hierarchy representing location inside the app
 * Example: 'BASIC_BUTTON_ADD_TEXT'
 */

export default {
  LANDING_PAGE_GENERAL_ERROR_TEXT: 'Kunde inte hitta användaren, är e-posten och koden korrekt?',
  LANDING_PAGE_END_DATE_LABEL: 'Sista datum för tillval är: ',
  LANDING_PAGE_EMAIL_INPUT_LABEL: 'Ange er e-postadress här',
  LANDING_PAGE_EMAIL_REQUIRED_TEXT: 'E-postadress krävs',
  LANDING_PAGE_EMAIL_VALID_TEXT: 'Ej giltig e-postadress',
  LANDING_PAGE_ACCESS_CODE_INPUT_LABEL: 'Ange er kod här',
  LANDING_PAGE_ACCESS_CODE_REQUIRED_TEXT: 'Kod krävs',
  LANDING_PAGE_ACCESS_CODE_MIN_LENGTH_TEXT: 'Kod måste vara minst 2 tecken lång',
  LANDING_PAGE_ACCESS_CODE_MAX_LENGTH_TEXT: 'Kod får inte bestå av fler än 5 tecken',
  LANDING_PAGE_INPUT_SUBMIT_BUTTON: 'Nästa',
  LANDING_PAGE_ANY_QUESTION: 'Vid frågor kontakta:',
  WELCOME_PAGE_TITLE: `Välkommen\u000A{name}!`,
  WELCOME_PAGE_ABORT_BUTTON: 'Avbryt',
  WELCOME_PAGE_START_BUTTON: 'Påbörja',
  WELCOME_PAGE_CONTINUE_BUTTON: 'Fortsätt',
  WELCOME_PAGE_APARTMENT_TYPE: 'Er lägenhetstyp:',
  WELCOME_PAGE_APARTMENT_NUMBER: 'Ert lägenhetsnummer:',
  WELCOME_PAGE_ANY_QUESTION: 'Vid frågor kontakta:',
  TOP_NAVIGATION_BAR_GO_BACK: 'Intro',
  BOTTOM_ACTION_BAR_BUTTON_TEXT: 'Sammanfattning',
  SUMMARY_PAGE_TITLE: 'Sammanfattning',
  SUMMARY_PAGE_PRIMARY_ACTION_LABEL: 'Bekräfta',
  SUMMARY_PAGE_SECONDARY_ACTION_LABEL: 'Tillbaka',
  SUMMARY_PAGE_ABPROVE_TERMS_AND_CONDITIONS_TITLE: 'Användarvillkor',
  SUMMARY_PAGE_ABPROVE_TERMS_AND_CONDITIONS: 'Jag godkänner <link>villkoren</link>',
  SUMMARY_PAGE_ABPROVE_TERMS_AND_CONDITIONS_BUTTON: 'Godkänn',
  SUMMARY_PAGE_TOTAL_LABEL: 'Summa',
  SUMMARY_PAGE_SUBMIT_SELECTION_ERROR: 'Ett problem uppstod när era val skulle sparas',
  SUMMARY_PAGE_APARTMENT_TYPE: 'Er lägenhetstyp:',
  SUMMARY_PAGE_APARTMENT_NUMBER: 'Ert lägenhetsnummer:',
  PRICE_DISPLAY_CAPTION_LABEL: 'Summa tillval',
  FINISH_PAGE_TITLE: 'Tack\u000A{name}!',
  FINISH_PAGE_END_BUTTON: 'Logga ut',
  PRIVATE_ROUTE_NOT_LOGGED_IN: 'Ej inloggad, <link>gå till</link> login sidan.',
  USE_FORMAT_PRICE_LABEL: 'Enligt offert',
  USE_FORMAT_TOTAL_PRICE_LABEL: 'Offererat pris tillkommer',
  ERROR_PAGE_HEADER: 'Något gick fel',
  ERROR_PAGE_INFO: 'Försök ladda om sidan, eller logga ut och logga in igen.',
  ERROR_PAGE_RESET_BUTTON: 'Ladda om',
  ERROR_PAGE_LOGOUT_BUTTON: 'Logga ut',
}
